import { UtilityModule } from "@/core/modules/utility/objects/UtilityModule";

import ItemCodeView from "./views/ItemCodeView.vue";

export const itemCode: UtilityModule = new UtilityModule("warehouse", "ItemCode", "warehouseUtility", ItemCodeView);
